import LilleSwitch from './packages/switch/index.js';

const components = [
	LilleSwitch
]

const install = function(Vue, opts = {}) {
	components.map(components => {
		Vue.component(component.name, component);
	})
}

/*支持实用标签的方式引入*/
if (typeof window !== 'undefined' && window.Vue) {
	install(window.Vue);
}

export default {
	install,
	LilleSwitch
}


// WEBPACK FOOTER //
// ./src/index.js